<h2 mat-dialog-title>
  <div class="dialog-title">
    <span>My Notes</span>
    @if (notesMetadata.updated_at) {
      <div class="metadata-header">
        <small>
          Last updated: {{ notesMetadata.updated_at | date:'medium' }}
          @if (notesMetadata.updated_by) {
            <span> by {{ notesMetadata.updated_by }}</span>
          }
        </small>
      </div>
    }
  </div>
</h2>

<mat-dialog-content>
  @if (isLoading) {
    <div class="loading-container">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  }

  @if (!isLoading) {
    <form [formGroup]="notesForm" class="notes-form">
      <div class="quill-container">
        <app-quill-wrapper [control]="adminNotesControl"></app-quill-wrapper>
      </div>
      <div class="metadata-footer">
        @if (notesMetadata.created_at) {
          <div class="metadata">
            <p class="metadata-text">
              <small>
                Created: {{ notesMetadata.created_at | date:'medium' }}
                @if (notesMetadata.created_by) {
                  <span> by {{ notesMetadata.created_by }}</span>
                }
              </small>
            </p>
          </div>
        }
      </div>
    </form>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Cancel</button>
  <button
    mat-raised-button
    color="primary"
    (click)="saveNotes()"
    [disabled]="isLoading || isSaving || notesForm.invalid">
    @if (!isSaving) {
      <mat-icon>save</mat-icon>
    }
    @if (isSaving) {
      <mat-spinner diameter="20" class="button-spinner"></mat-spinner>
    }
    Save
  </button>
</mat-dialog-actions>